/**
 * Do not remove
 * This indicates locale-specific pre-processor which filename to use before building
 * Renaming is done by prepareLocale yarn script and should be run on every locale change
 * @pragma filename('resort.lift-tickets')
 */
import { ResortLayout } from 'page-components/resort/_layout';
import Component, { getResortLiftTicketsServerSideProps } from 'page-components/resort/lift-tickets';
import { propsWithI18NSSR } from 'util/propsWithI18n';
/* import { fetchResortSlugs } from 'util/fetchResortSlugs';
import { isMainLocale } from 'util/i18nFlags';
import { packPaths } from 'util/packPaths'; */

export default Object.assign(Component, { Layout: ResortLayout });

export const getServerSideProps = propsWithI18NSSR(getResortLiftTicketsServerSideProps);

/* export const getStaticPaths = async () => packPaths(
  isMainLocale() ? (await fetchResortSlugs('resort.lift-tickets')).map((res) => ({
    region: res.region,
    resort: res.slug,
  })) : [],
); */
